import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Center,
  Box,
  Alert,
  Code,
  Collapse,
  Group,
  Divider,
} from "@mantine/core";
import {
  IconAlertTriangle,
  IconHome,
  IconRefresh,
  IconChevronDown,
  IconChevronUp,
} from "@tabler/icons-react";
import { useState } from "react";
import Logo from "./Logo";

function ErrorFallback({ error, resetErrorBoundary }) {
  const [showDetails, setShowDetails] = useState(false);

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <>
      <Box
        style={{
          borderBottom: "1px solid var(--mantine-color-divider)",
        }}
        p="lg"
      >
        <Group justify="flex-start" pl="lg">
          <Logo showTitle={true} />
        </Group>
      </Box>

      <Container size="xl">
        <Center mih="80vh">
          <Stack align="center" gap="lg" w="100%">
            <Box>
              <IconAlertTriangle size={80} color="var(--mantine-color-red-5)" />
            </Box>

            <Stack align="center" gap="sm" w="100%">
              <Title order={1}>Oops! Something went wrong</Title>

              <Text size="md" c="gray.6" ta="center">
                An unexpected error occurred. Our team has been notified.
              </Text>

              <Stack gap="sm" align="center" mt="md" w="100%">
                <Button
                  leftSection={<IconRefresh size={16} />}
                  onClick={resetErrorBoundary || handleReload}
                  color="gray"
                  variant="outline"
                >
                  Try Again
                </Button>
                <Divider orientation="horizontal" w="20%" label="OR" pt="sm" />
                <Button
                  leftSection={<IconHome size={16} />}
                  onClick={handleGoHome}
                  color="gray"
                  variant="subtle"
                  size="sm"
                >
                  Go to Home
                </Button>
              </Stack>

              {import.meta.env.DEV && error && (
                <Stack gap="sm" w="100%" mt="xl">
                  <Button
                    rightSection={
                      showDetails ? (
                        <IconChevronUp size={16} />
                      ) : (
                        <IconChevronDown size={16} />
                      )
                    }
                    variant="subtle"
                    color="gray"
                    size="sm"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    {showDetails ? "Hide" : "Show"} Error Details
                  </Button>

                  <Collapse in={showDetails}>
                    <Alert
                      color="red"
                      title="Error Details (Development Only)"
                      variant="light"
                    >
                      <Stack gap="xs">
                        <Text size="sm" fw={500}>
                          {error.name}: {error.message}
                        </Text>
                        {error.stack && (
                          <Code
                            block
                            fz="xs"
                            mah={200}
                            style={{ overflow: "auto" }}
                          >
                            {error.stack}
                          </Code>
                        )}
                      </Stack>
                    </Alert>
                  </Collapse>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Center>
      </Container>
    </>
  );
}

export default ErrorFallback;
